import { ref, onUnmounted } from '@vue/composition-api'

export function usePickAndPlace() {
  const isPickMode = ref(false)
  let ghostEl = null
  let onEndCallback = null


  function startPick(config) {
    if (isPickMode.value) cancelPick()

    isPickMode.value = true
    onEndCallback = config.onEnd || null

    if (config.onStart) config.onStart()


    ghostEl = document.createElement('div')
    ghostEl.innerHTML = config.ghostHtml || 'Click para soltar'
    ghostEl.style.cssText = `
      position: fixed;
      pointer-events: none;
      z-index: 9999;
      padding: 8px 14px;
      background: var(--primary);
      color: white;
      border-radius: 6px;
      font-size: 13px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      opacity: 0.85;
      transform: translate(-50%, -50%);
      white-space: nowrap;
    `
    document.body.appendChild(ghostEl)
    document.body.style.cursor = 'grabbing'

    window.addEventListener('mousemove', onMouseMove)
    window.addEventListener('click', onClickEnd, { capture: true })
    window.addEventListener('keydown', onEscape)
  }

  function onMouseMove(e) {
    if (!ghostEl) return
    ghostEl.style.left = `${e.clientX}px`
    ghostEl.style.top = `${e.clientY}px`
  }

  function onClickEnd(e) {
    if (!isPickMode.value) return
    cleanup()
  }

  function onEscape(e) {
    if (e.key === 'Escape') cancelPick()
  }

  function cancelPick() {
    if (onEndCallback) onEndCallback()
    cleanup()
  }

  function cleanup() {
    if (onEndCallback) onEndCallback()
    onEndCallback = null

    isPickMode.value = false

    if (ghostEl) {
      ghostEl.remove()
      ghostEl = null
    }

    document.body.style.cursor = ''
    window.removeEventListener('mousemove', onMouseMove)
    window.removeEventListener('click', onClickEnd, { capture: true })
    window.removeEventListener('keydown', onEscape)
  }

  onUnmounted(() => cleanup())

  return { isPickMode, startPick, cancelPick }
}
